var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDelete(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13,
    height: 16,
    viewBox: "0 0 13 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Union_2",
    "data-name": "Union 2",
    d: "M4.258-3753.832c-.233,0-.423-.128-.423-.32v-.9a.38.38,0,0,1,.423-.333H8.8a.373.373,0,0,1,.4.333v.9a.364.364,0,0,1-.4.32Zm6.061-.609v-.608a1.444,1.444,0,0,0-1.557-1.275H4.225a1.43,1.43,0,0,0-1.543,1.275v.608H1.968a.791.791,0,0,1-.849-.674l-.33-8.9a.635.635,0,0,1,.239-.506.961.961,0,0,1,.61-.216H11.35a.956.956,0,0,1,.609.216.634.634,0,0,1,.239.507l-.33,8.9a.789.789,0,0,1-.848.673ZM.962-3766.527A1.009,1.009,0,0,1,0-3767.578v-1.2a1.01,1.01,0,0,1,.962-1.052H12.039A1.01,1.01,0,0,1,13-3768.78v1.2a1.009,1.009,0,0,1-.961,1.052Z",
    transform: "translate(0 3769.832)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.485424a350648786401787128531ef4d.svg";
export { ForwardRef as ReactComponent };